module.exports = __webpack_public_path__ + "img/vessel.d09f2390.png";